import createReducer from './createReducer';
import {
  FETCH_PREMIUM_PERKS,
  FETCH_PREMIUM_PERKS_SUCCESS,
  FETCH_PREMIUM_PERKS_FAILURE,
} from '../actions/promotions';

const initialState = {
  premiumPerks: {},
};

const handlers = {};

handlers[FETCH_PREMIUM_PERKS] = (state) => ({
  ...state,
  loading: true,
});

handlers[FETCH_PREMIUM_PERKS_SUCCESS] = (state, { premiumPerks }) => ({
  ...state,
  loading: false,
  premiumPerks,
});

handlers[FETCH_PREMIUM_PERKS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);
